<div #addOwnerButton class="offcanvas offcanvas-end customeoff {{ owner_add_edit?'show':''}}" tabindex="-1" id="owner_add_edit" data-bs-backdrop="static">
    <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">Personal Information</h5>
      <button type="button" class="btn-close" aria-label="Close"  (click)="close()">
          <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="container-fluid" *ngIf="userForm">
        <form [formGroup]="userForm" (ngSubmit)="onSubmit()" autocomplete="off">
          <div class="display">
              <label>Profile Picture</label>
              <div class="dz-default dlab-message upload-img mb-3">	
                  <div class="dropzone">
                      <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M27.1666 26.6667L20.4999 20L13.8333 26.6667" stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M20.5 20V35" stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M34.4833 30.6501C36.1088 29.7638 37.393 28.3615 38.1331 26.6644C38.8731 24.9673 39.027 23.0721 38.5703 21.2779C38.1136 19.4836 37.0724 17.8926 35.6111 16.7558C34.1497 15.619 32.3514 15.0013 30.4999 15.0001H28.3999C27.8955 13.0488 26.9552 11.2373 25.6498 9.70171C24.3445 8.16614 22.708 6.94647 20.8634 6.1344C19.0189 5.32233 17.0142 4.93899 15.0001 5.01319C12.9861 5.0874 11.015 5.61722 9.23523 6.56283C7.45541 7.50844 5.91312 8.84523 4.7243 10.4727C3.53549 12.1002 2.73108 13.9759 2.37157 15.959C2.01205 17.9421 2.10678 19.9809 2.64862 21.9222C3.19047 23.8634 4.16534 25.6565 5.49994 27.1667" stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M27.1666 26.6667L20.4999 20L13.8333 26.6667" stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div class="fallback">
                          <input name="file" type="file" >
                      </div>
                    </div>
              </div>	
          </div>
         
              <div class="row">
                  <div class="col-xl-6 mb-3">
                      <label for="exampleFormControlInput1-1" class="form-label">First Name<span class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="user" formControlName="first_name">
                      <div *ngIf="userForm?.get('first_name')?.invalid && userForm?.get('first_name')?.touched" class="required">
                        First Name is required
                    </div>
                  </div>	
                  <div class="col-xl-6 mb-3">
                      <label for="exampleFormControlInput1-2" class="form-label">Last Name<span class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="exampleFormControlInput1-2" placeholder="user1" formControlName="last_name">
                      <div *ngIf="userForm?.get('last_name')?.invalid && userForm?.get('last_name')?.touched" class="required">
                        Last Name is required
                    </div>
                  </div>	
                  <div class="col-xl-6 mb-3">
                      <label for="exampleFormControlInput1-3" class="form-label">Email<span class="text-danger">*</span></label>
                      <input type="email" class="form-control" id="exampleFormControlInput1-3" placeholder="abc@aa.com" formControlName="email">
                      <div *ngIf="userForm?.get('email')?.invalid && userForm?.get('email')?.touched" class="required">
                        Provide valid email 
                    </div>
                  </div>
                  <div class="col-xl-6 mb-3">
                      <label for="exampleFormControlInput1-4" class="form-label">Mobile Number<span class="text-danger">*</span></label>
                      <ngx-intl-tel-input
                      formControlName="phone" [cssClass]="'default-select style-1 form-control'"   [preferredCountries]="['in','us', 'gb', 'ca']" [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"	[selectFirstCountry]="false" [maxLength]="15" [phoneValidation]="true" [separateDialCode]="true" autcomplete="off"></ngx-intl-tel-input>
                    <div *ngIf="userForm?.get('phone')?.errors && userForm?.get('phone')?.touched" class="required">
                        Provide valid mobile number
                    </div>                                            
                  </div>
                  <div class="col-xl-6 mb-3">
                    <label for="exampleFormControlInput1-3" class="form-label">Alternate Email</label>
                    <input type="email" class="form-control" id="exampleFormControlInput1-3" placeholder="aa@aa.com" formControlName="alternate_email">                                       
                  </div>
                  <div class="col-xl-6 mb-3">
                    <label for="exampleFormControlInput1-4" class="form-label">Alternate Mobile Number</label>
                    <ngx-intl-tel-input
                    formControlName="alternate_phone" [cssClass]="'default-select style-1 form-control'"   [preferredCountries]="['in','us', 'gb', 'ca']" [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"	[selectFirstCountry]="false" [maxLength]="15" [phoneValidation]="false" [separateDialCode]="true" autcomplete="off"></ngx-intl-tel-input>    
                </div>
                <div class="col-xl-6 mb-3">
                    <label for="exampleFormControlInput1-3" class="form-label">Gender</label>
                <div>
                    <mat-radio-group aria-label="Select gender" formControlName="gender">
                        <mat-radio-button value="male">Male</mat-radio-button>
                        <mat-radio-button value="female">Female</mat-radio-button>
                        <mat-radio-button value="others">Others</mat-radio-button>
                    </mat-radio-group> 
                </div>                                           
                </div>  
                <div class="col-xl-6 mb-3">
                    <label for="exampleFormControlInput1-3" class="form-label">Date of birth</label>
                <div>
                    <mat-form-field>
                        <mat-label>Select dob</mat-label>
                        <input matInput [matDatepicker]="dp3" [matDatepickerFilter]="disableFutureDates" formControlName="dob">
                        <mat-datepicker-toggle matIconSuffix [for]="dp3" ></mat-datepicker-toggle>
                        <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                    </mat-form-field>  
                </div>                                          
                </div> 
                <div class="col-xl-6 mb-3">
                    <label for="exampleFormControlInput1-3" class="form-label">Driving License No</label>
                    <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="D123456" formControlName="driving_license">                                            
                  </div>

                  <div class="col-xl-6 mb-3">
                    <label for="exampleFormControlInput1-3" class="form-label">Marital Status</label>
                    <select class="form-select" formControlName="marital_status">
                        <option  data-display="Select" value="null" selected disabled>Please select</option>
                        <option value="single">Single</option>                          
                        <option value="married">Married</option>
                        <option value="widow">Widow</option>
                        <option value="widower">Widower</option>
                    </select>                                            
                  </div>

                  <div class="col-xl-6 mb-3">
                    <label for="exampleFormControlInput1-3" class="form-label">Aadhaar Number</label>
                    <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="1234 5678 9009" formControlName="aadhar">                                            
                  </div> 

                  <div class="col-xl-6 mb-3">
                    <label for="exampleFormControlInput1-3" class="form-label">Pan Number</label>
                    <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="BLP0I3245U" formControlName="pan">                                            
                  </div> 

              </div>
              <div>
                  <button class="btn btn-primary ms-1 me-3" type="submit" [disabled]="userForm.invalid" *ngIf="checkUserPersonalInfoUpdate">Save</button>
                  <button class="btn btn-danger lightme-1" type="button" (click)="close()">Cancel</button>
              </div>
          </form>
        </div>
    </div>
  </div>		
  @if(owner_add_edit){
    <div class="offcanvas-backdrop fade show" (click)="toggleExample()"></div>
}